import { Collapse } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';

export function ShowWhenEnabled({
  enabledPath,
  children,
}: {
  enabledPath: string;
  children: React.ReactNode;
}) {
  const form = useFormContext();
  const isEnabled = useWatch({
    name: enabledPath,
    control: form.control,
  });

  return (
    <Collapse
      in={isEnabled}
      animateOpacity
      style={{
        padding: '2px',
        margin: '-2px',
      }}
    >
      {children}
    </Collapse>
  );
}
